import React, { useState } from "react";
import "../../../styles/TablesSBoardType3.css";
import shuffleArray from "../shuffleArray";
import { BoardProps, InputRoundType3 } from "../../types/types";
import { useGame } from "../../../GameContext";
import { useTimerActions } from "../../../TimerContext";
import createRoundType3 from "./utils/createRoundType3";
import RenderBoardLogo from "../RenderBoardLogo";
import RenderGameCard from "../RenderGameCard";
import RenderTableType3 from "./RenderTableType3";
import MESSAGES from "../message";
type PuzzleLine = {
  cipher: string;
  key: string;
  answer: string;

  value: string;
  status: "idle" | "active" | "wrong" | "correct";
};
const BoardType3: React.FC<BoardProps> = ({ rounds, random,type}) => {
  const { isGameStarted, setGameStarted, setMessage } = useGame();
  const { startTimer, stopTimer, resetTimer } = useTimerActions();
  const createRoundOrder = () => {
    const indexes = roundsData.map((_, index) => index);

    return random ? shuffleArray(indexes) : indexes;
  };
  const roundsData = rounds as InputRoundType3[];
  const [roundOrder, setRoundOrder] = useState(() => createRoundOrder());

  const [roundIndex, setRoundIndex] = useState(0);

  const isLastRound = roundIndex === roundsData.length - 1;
  const [roundsLines, setRoundsLines] = useState(() =>
    roundsData.map((round) => createRoundType3(round)),
  );

  const currentRoundIndex = roundOrder[roundIndex];

  const lines = roundsLines[currentRoundIndex];

  const updateLines = (newLines: PuzzleLine[]) => {
    setRoundsLines((prev) => {
      const copy = [...prev];
      copy[currentRoundIndex] = newLines;
      return copy;
    });
  };
  const [activeLine, setActiveLine] = useState(0);
  const [isGameFinished, setIsGameFinished] = useState(false);

  const normalize = (text: string) =>
    text.trim().replace(/\s+/g, " ").toUpperCase();

  const resetRound = () => {
    setActiveLine(0);
  };
  const startRound = () => {
    resetRound();

    startTimer();

    setMessage(MESSAGES.START);
  };
  const finishRound = () => {
    stopTimer();
  };
  const resetGame = () => {
    resetTimer();

    setRoundsLines(roundsData.map((round) => createRoundType3(round)));

    setRoundOrder(createRoundOrder());

    setRoundIndex(0);
    setActiveLine(0);

    setIsGameFinished(false);
  };

  const restartGame = () => {
    resetGame();
    startRound();
  };

  const handleStart = () => {
    setGameStarted(true);
    startRound();
  };
  const startNextRound = () => {
    setRoundIndex((prev) => prev + 1);
    startRound();
  };
  const nextGuessed = () => {
    if (isGameFinished) {
      restartGame();
      return;
    }

    startNextRound();
  };

  const checkAnswer = (index: number) => {
    const line = lines[index];

    if (!line.value.trim()) {
      const copy = [...lines];
      copy[index].status = "wrong";
      updateLines(copy);

      setMessage(MESSAGES.ENTER_ANSWER);
      return;
    }

    if (normalize(line.value) !== normalize(line.answer)) {
      const copy = [...lines];
      copy[index].status = "wrong";
      updateLines(copy);

      setMessage(MESSAGES.ANSWER_WRONG);
      return;
    }

    const copy = [...lines];
    copy[index].status = "correct";
    updateLines(copy);

    if (index < copy.length - 1) {
      setActiveLine(index + 1);
      setMessage(MESSAGES.START_TYPE2);
      return;
    }

    finishRound();

    if (isLastRound) {
      setIsGameFinished(true);
      setMessage(MESSAGES.GAME_FINISHED);
      return;
    }

    setMessage(MESSAGES.ROUND_FINISHED);
  };
  return (
    <div className="tableS-Board">
      <div className="tableS-board-content">
        <RenderBoardLogo
          isGameStarted={isGameStarted}
          isGameFinished={isGameFinished}
          onNext={nextGuessed}
          onStart={handleStart}
          type={type}
        />
        <div className="tableS-board-game--Type3">
          <RenderGameCard isGameFinished={isGameFinished}>
            <RenderTableType3
              lines={lines}
              setLines={updateLines}
              activeLine={activeLine}
              setActiveLine={setActiveLine}
              checkAnswer={checkAnswer}
              isGameStarted={isGameStarted}
            />
          </RenderGameCard>
        </div>
      </div>
    </div>
  );
};

export default BoardType3;
